import React from "react";
import i18next from "../../assets/i18n/i18n";

export default class AccountStatusNokLogo extends React.Component {
    render(): React.ReactElement {
        return (
            <svg
                width="62"
                height="62"
                viewBox="0 0 62 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`account-status-logo-${i18next.language}`}
            >
                <g clipPath="url(#clip0)">
                    <path
                        d="M3.3175 44.4383C0.705899 41.8267 -0.64947 36.771 0.305954 33.204L5.52062 13.7451C6.47604 10.1781 10.1781 6.47604 13.7451 5.52062L33.204 0.305954C36.771 -0.64947 41.8267 0.705899 44.4383 3.3175L58.6825 17.5617C61.2941 20.1682 62.6478 25.229 61.7009 28.796L56.4794 48.2549C55.524 51.8219 51.8219 55.524 48.2549 56.4794L28.796 61.7009C25.229 62.6563 20.1733 61.3027 17.5617 58.6911L3.3175 44.4383Z"
                        fill="#BE1A33"
                    />
                    <path
                        d="M34.9609 30.75L42.3828 23.3281C43.3477 22.4375 43.3477 20.9531 42.3828 20.0625L40.75 18.4297C39.8594 17.4648 38.375 17.4648 37.4844 18.4297L30.0625 25.8516L22.5664 18.4297C21.6758 17.4648 20.1914 17.4648 19.3008 18.4297L17.668 20.0625C16.7031 20.9531 16.7031 22.4375 17.668 23.3281L25.0898 30.75L17.668 38.2461C16.7031 39.1367 16.7031 40.6211 17.668 41.5117L19.3008 43.1445C20.1914 44.1094 21.6758 44.1094 22.5664 43.1445L30.0625 35.7227L37.4844 43.1445C38.375 44.1094 39.8594 44.1094 40.75 43.1445L42.3828 41.5117C43.3477 40.6211 43.3477 39.1367 42.3828 38.2461L34.9609 30.75Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0">
                        <rect width="62" height="62" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}
